import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';
import { IContract } from '@models/contract.class';
import { EventSuccess } from '@models/tracking-success-event.class';
import { map } from 'rxjs/operators';
import { TRACKING_EVENTS } from 'src/app';
import { CashService } from 'src/core';
import { MixpanelService } from 'src/core/services/mixpanel.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'deposit-account',
  templateUrl: './depositAccount.component.html',
  styleUrls: ['./depositAccount.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DepositAccountComponent implements OnChanges {
  @Input() currentContract: IContract;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() isLoadedDepositAccount: EventEmitter<boolean> = new EventEmitter();
  public showAnimated = false;
  public formattedCLABE = '';
  public hasError = false;
  public informationMessage = 'Cargando...';

  private successfulMessage =
    'Registra la siguiente información en tu banca electrónica. Ahora puedes hacer depósitos en cualquier momento y los verás reflejados en máximo 10 minutos.';
  private errorMessage =
    'No se pudo obtener la cuenta CLABE. Intente más tarde.';

  constructor(
    private cashService: CashService,
    private readonly mixpanelService: MixpanelService,
  ) {}

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { currentContract } = changes;
    if (
      currentContract &&
      currentContract.currentValue &&
      currentContract.currentValue.contractID
    ) {
      this.init();
    }
  }

  public hide() {
    this.showAnimated = false;
    this.isLoadedDepositAccount.next(false);
    setTimeout(() => {
      this.onClose.next(true);
    }, 500);
  }

  public copyCLABE(): void {
    const successEvent = new EventSuccess();
    successEvent.setType(this.currentContract.isUsa);
    const successEventData = successEvent.getEventSuccess();

    this.mixpanelService.track(
      TRACKING_EVENTS.clabe_copied.event,
      successEventData,
    );
  }

  private init() {
    this.formattedCLABE = '';
    if (this.currentContract.contractID) {
      this.getCLABE(this.currentContract.contractID).subscribe(
        (clabe) => {
          this.isLoadedDepositAccount.next(true);
          this.formattedCLABE = clabe;
          this.informationMessage = this.successfulMessage;
          this.showAnimated = true;
        },
        () => {
          this.isLoadedDepositAccount.next(true);
          this.hasError = true;
          this.informationMessage = this.errorMessage;
          this.showAnimated = true;
        },
      );
    } else {
      this.hasError = true;
    }
  }

  private getCLABE(contractId: string) {
    return this.cashService
      .getCLABE(contractId)
      .pipe(map((claveResponse) => claveResponse.response));
  }
}
